export default __webpack_public_path__ + "static/blockchain-header-b406953c0afb134a4b3c227d0a636f21.jpg";